declare var gtag: Function;

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class AnalyticsService {

  constructor() { }

  /* Track Page View */
  trackPageView(url: string) {
    gtag('config', 'G-G7JBXRGBZ2', {
      page_path: url
    });
  }

  /* Track Custom Events */
  trackEvent(eventName: string, eventParams?: any) {
    gtag('event', eventName, eventParams);
  }

}
